module.exports = __webpack_public_path__ + "media/images/shark/Leona-b0f6a85306fb9ff937a7c3fe09440a84.jpg";